// eslint-disable-next-line import/no-named-as-default
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import checkoutBg from '../locales/bg/checkout.json';
import commonBg from '../locales/bg/common.json';
import designerBg from '../locales/bg/designer.json';
import errorsBg from '../locales/bg/errors.json';
import homeBg from '../locales/bg/home.json';
import legalBg from '../locales/bg/legal.json';
import productsBg from '../locales/bg/products.json';
import checkoutEn from '../locales/en/checkout.json';
import commonEn from '../locales/en/common.json';
import designerEn from '../locales/en/designer.json';
import errorsEn from '../locales/en/errors.json';
import homeEn from '../locales/en/home.json';
import legalEn from '../locales/en/legal.json';
import productsEn from '../locales/en/products.json';

const resources = {
  bg: {
    common: commonBg,
    products: productsBg,
    designer: designerBg,
    checkout: checkoutBg,
    errors: errorsBg,
    home: homeBg,
    legal: legalBg,
  },
  en: {
    common: commonEn,
    products: productsEn,
    designer: designerEn,
    checkout: checkoutEn,
    errors: errorsEn,
    home: homeEn,
    legal: legalEn,
  },
};

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: 'common',
    fallbackLng: 'bg',
    lng: 'bg',
    supportedLngs: ['bg', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
